<template>
    <tr>
        <td class="px-6 py-3">
            {{ value.name }}
        </td>
        <td class="px-6 py-3">
            <a class="cursor-pointer" :class="{'font-bold': access === 'write'}" @click="set('write')">write</a>
            <a class="cursor-pointer" :class="{'font-bold': access === 'read'}" @click="set('read')">read</a>
            <a class="cursor-pointer" :class="{'font-bold': access === 'none'}" @click="set('none')">none</a>
        </td>
    </tr>
</template>

<script>
export default {
    name: "PermissionItem",

    props: ['value'],

    data: (vm) => ({
        access: vm.value.access,
    }),

    methods: {
        set(val) {
            this.access = val;
            this.value.access = val;
            this.$emit("input", this.value)
        }
    }
}
</script>

<style scoped>

</style>
